import { BaseQuery } from './BaseQuery';
import { IExecutionOptions } from '../models/query';
import { IQueryOptionsDocument } from '../models/query/options';
import { Query } from './Query';
import { IDocument } from "../models/api/search";

export class SingleDocumentQuery extends BaseQuery<IQueryOptionsDocument> {
	initialize(executionOptions: IExecutionOptions) {
		this.fillKeyFromQuery('key', 'keyQuery', executionOptions);
	}
	getOptions(): IQueryOptionsDocument {
		const { key, keyQuery, childKey, options = {} } = this.queryOptions;
		return {
			key,
			keyQuery,
			childKey,
			...(options.fundManager || {}),
		};
	}
	getRawValue<T = any>(executionOptions: IExecutionOptions): T {
		const {
			key,
			childKey,
		} = this.options;
		const context = Query.getContext(executionOptions, this.queryOptions);
		let document: IDocument;
		if (context) {
			document = context.document;
		}
		if (document) {
			if (key) {
				const { meta, inferred } = document;
				if (key === 'meta' && meta) {
					return childKey &&  meta[childKey] && meta[childKey].value;
				}
				if (key === 'inferred' && inferred) {
					return childKey &&  inferred[childKey] && inferred[childKey].value;
				}
				return document[key];
			}
			return document as any;
		}
		return;
	}
}